import common from './common.json';
import login from './login.json';
import labels from './labels.json';
import messeger from './messeger.json';
import polls from './polls.json';
import news from './news.json';
import wiki from './wiki.json';
import schedule from './schedule.json';

const messages = {
  common,
  login,
  labels,
  messeger,
  polls,
  news,
  wiki,
  schedule
};

export default messages;